import React from 'react';

/**
 * CarouselCard Component
 * Displays walkthrough step content in a mobile-optimized card
 */
const CarouselCard = ({ step, isWelcome }) => {
  if (!step) return null;

  return (
    <div className={`carousel-card ${isWelcome ? 'carousel-card-welcome' : 'carousel-card-transparent'}`}>
      <div className="carousel-card-content">
        <h2 id="carousel-title" className="carousel-card-title">
          {step.content.title}
        </h2>
        <p className="carousel-card-description">
          {step.content.description}
        </p>
        {step.content.signature && (
          <p className="carousel-card-signature">
            {step.content.signature}
          </p>
        )}
      </div>
    </div>
  );
};

export default CarouselCard;
